import React, { Component } from "react";

export default class CompanyDocs extends Component {
  constructor(props) {
    super(props);
    this.refs = {
      companyDocsForm: React.createRef(),
      declinedRemarksForm: React.createRef(),
    };
    this.outerclass = "col-12 d-flex flex-wrap";
    this.passwordclass = "";
    this.fields = [];
  }
  componentDidMount() {
    this.setState({
      fields: [
        { label: "Certificate of incorporation", name: "incorpCertificate" },
      ],
    });
  }
  saveBankStatement() {
    console.log(
      "saveBankStatement values:",
      this.refs.companyDocsForm.form.current.getData()
    );
  }
  saveDeclinedRemarks() {
    console.log(
      "saveDeclinedRemarks values:",
      this.refs.declinedRemarksForm.form.current.getData()
    );
  }
  render() {
    let { passwordclass, outerclass, status, icons, fields } = this;
    return (
      <>
        <AppForm
          ref="companyDocsForm"
          id="companyDocsForm"
          onSubmit={() => this.saveBankStatement()}
        >
          {/* {fields.map((field) => {
            <div className="row d-flex mb-3 g-3">
              <label htmlFor="test" className="col-12 col-md-2 col-form-label">
                {field.label}
              </label>
              <div className="col-12 col-md-10 d-flex flex-wrap">
                <div className="row">
                  <AppUploadPassword
                    inputName={field.name}
                    passwordclass={passwordclass}
                    outerclass={outerclass}
                    editaccess="false"
                  />
                </div>
              </div>
            </div>;
          })} */}

          <div className="row d-flex mb-3 g-3">
            <label htmlFor="test" className="col-12 col-md-2 col-form-label">
              Certificate of incorporation
            </label>
            <div className="col-12 col-md-10 d-flex flex-wrap">
              <div className="row">
                <AppUploadPassword
                  inputName={`incorpCertificate`}
                  passwordclass={passwordclass}
                  outerclass={outerclass}
                  editaccess="false"
                />
              </div>
            </div>
          </div>

          <div className="row d-flex mb-3 g-3">
            <label htmlFor="test" className="col-12 col-md-2 col-form-label">
              Remarks
            </label>
            <div className="col-12 col-md-4">
              <AppInput type="text" placeholder="Enter Remarks" />
            </div>
          </div>

          <div className="row d-flex mb-3 g-3">
            <label htmlFor="test" className="col-12 col-md-2 col-form-label">
              Company Pancard
            </label>
            <div className="col-12 col-md-10 d-flex flex-wrap">
              <div className="row">
                <AppUploadPassword
                  inputName={`companyPAN`}
                  passwordclass={passwordclass}
                  outerclass={outerclass}
                  editaccess="false"
                />
              </div>
            </div>
          </div>

          <div className="row d-flex mb-3 g-3">
            <label htmlFor="test" className="col-12 col-md-2 col-form-label">
              Partnership Deed
            </label>
            <div className="col-12 col-md-10 d-flex flex-wrap">
              <div className="row">
                <AppUploadPassword
                  inputName={`partnerDeed`}
                  passwordclass={passwordclass}
                  outerclass={outerclass}
                  editaccess="false"
                />
              </div>
            </div>
          </div>

          <div className="row d-flex mb-3 g-3">
            <label htmlFor="test" className="col-12 col-md-2 col-form-label">
              GST Registration
            </label>
            <div className="col-12 col-md-10 d-flex flex-wrap">
              <div className="row">
                <AppUploadPassword
                  inputName={`gstRegist`}
                  passwordclass={passwordclass}
                  outerclass={outerclass}
                  editaccess="false"
                />
              </div>
            </div>
          </div>

          <div className="row mx-auto align-items-center mt-3">
            <div className="col-12">
              <button
                type="submit"
                className="btn add-btn grey ms-2 text-dark rounded-pill"
              >
                Submit
              </button>
              <button
                type="submit"
                className="btn add-btn btn-warning text-dark rounded-pill"
              >
                Save
              </button>
              {/* <a
                href="#"
                className="btn add-btn"
                data-bs-toggle="modal"
                data-bs-target="#companyDocsModal"
              >
                <i className="fa fa-plus" /> Add Client
              </a> */}
            </div>
          </div>
        </AppForm>
        <AppContentModal
          title="Declined Remarks"
          id="companyDocsModal"
          footer={["cancel", "save"]}
        >
          <AppForm
            className="row mb-2"
            ref="declinedRemarksForm"
            onSubmit={() => saveDeclinedRemarks()}
          >
            <div className="row align-items-center mt-3">
              <div className="col-12">
                <AppInput
                  type="textarea"
                  name="remarks"
                  label="Enter Remarks"
                  placeholder="Enter Remarks"
                ></AppInput>
              </div>
            </div>
          </AppForm>
        </AppContentModal>
      </>
    );
  }
}